import { useQuery } from 'data-fetching-client';
import { CRM_SEARCH } from 'email-management-lib/refactor/queries/crm';
import { MARKETING_EMAIL_OBJECT_TYPE } from 'email-management-lib/Shared/constants/frameworkTable';
import { useMemo } from 'react';
function useFetchViewCount(view) {
  var _view$filterGroups, _view$quickFilters;
  const requestBody = {
    objectTypeId: MARKETING_EMAIL_OBJECT_TYPE,
    filterGroups: (_view$filterGroups = view === null || view === void 0 ? void 0 : view.filterGroups) !== null && _view$filterGroups !== void 0 ? _view$filterGroups : [],
    quickFilters: (_view$quickFilters = view === null || view === void 0 ? void 0 : view.quickFilters) !== null && _view$quickFilters !== void 0 ? _view$quickFilters : [],
    requestOptions: {
      allPropertiesFetchMode: 'latest_version',
      includeAllProperties: false
    }
  };
  const {
    data,
    loading,
    error
  } = useQuery(CRM_SEARCH, {
    // @ts-expect-error missing count, offset, query, sorts
    variables: {
      requestBody
    },
    skip: !view
  });
  return useMemo(() => ({
    count: loading || error || !data ? 0 : data.emailCrmSearch.total
  }), [data, error, loading]);
}
export default useFetchViewCount;